<div class="p-20 fx-row fx-wrap align-items-center justify-content-center text-center">
    <div class="fx-flex-100 align-items-center justify-content-center text-center">
        <span class="title mb-10 text-center">{{(mode == 'create' ? 'ORGANIZATION.CREATE_TAG' : 'ORGANIZATION.EDIT_TAG'
            ) | translate}}</span>
    </div>
    <span class="text mt-20">{{(mode == 'create' ? 'ORGANIZATION.CREATE_TAG_HINT' : 'ORGANIZATION.EDIT_TAG_HINT'
        ) | translate:organization}}</span>
    <div class="fx-flex-100 fx-row fx-wrap align-items-center justify-content-center mt-20">
        <app-input [placeholder]="('TAG.LABEL' | translate) + '...'" type="text" class="mb-10 fx-flex-100"
            [(value)]="tagToCreate.label" [error]="errors['label']" [bottomWrapper]="true"
            (change)="onLabelChange($event)"></app-input>
        <app-input [placeholder]="('TAG.DESCRIPTION' | translate) + '...'" type="text" class="mb-10 fx-flex-100"
            [(value)]="tagToCreate.description" [bottomWrapper]="true"></app-input>
    </div>
    <mat-divider class="fx-flex-100 mv-20"></mat-divider>
    <div class="fx-row align-items-center justify-content-center fx-flex-100">
        <button class="button fx-flex mr-10" (click)="onCancel()">{{'ACTIONS.CANCEL' | translate}}</button>
        <button class="main-button fx-flex ml-10" (click)="mode == 'create' ? onCreate() : onEdit()"
            [class.disabled]="isDisabled()" [disabled]="isDisabled()">{{(mode == 'create' ? 'ACTIONS.CREATE' :
            'ACTIONS.EDIT'
            )
            | translate}}</button>
    </div>
</div>